export default [
  {
    path: '/fraud-trips',
    name: 'fraud-trips',
    component: () => import('@/views/fraud-trips/pages/FraudTrips.vue'),
    meta: {
      resource: 'fraud-trips',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Fraud Trips',
      breadcrumb: [
        {
          text: 'Fraud Trips',
          active: true,
        },
      ],
    },
  },

]
